import { Controller } from "@hotwired/stimulus"

// Narrows a long list in the browser instead of paginating it: the wildlife
// pages are drag-sorted, so the list has to stay whole. Rows carry
// data-list-filter-name; a section with nothing left in it hides too.
export default class extends Controller {
  static targets = ["input", "status"]

  connect() {
    this.rows = Array.from(document.querySelectorAll("[data-list-filter-name]"))
    this.sections = Array.from(document.querySelectorAll("[data-list-filter-section]"))
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let shown = 0

    this.rows.forEach((row) => {
      const matches = !query || row.dataset.listFilterName.includes(query)
      row.hidden = !matches
      if (matches) shown++
    })

    this.sections.forEach((section) => {
      section.hidden = query.length > 0 && !section.querySelector("[data-list-filter-name]:not([hidden])")
    })

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = query ? `${shown} of ${this.rows.length} shown` : ""
    }
  }
}
